import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Section from './Section';

export default class extends Component {
  static propTypes = {
    section: PropTypes.object.isRequired,
  }

  render() {
    return (
      <Section title={this.props.section.title}
        previewButtonProps={{
          previewPath: this.props.section.previewPath,
          target: this.props.section.slug,
          disabled: this.props.section.disablePreviewWithTooltip !== undefined,
          disabledTooltip: this.props.section.disablePreviewWithTooltip,
        }}>
        <div>
          <p className="u-infoText">
            This section is read-only. You can preview it using the button on the right.
          </p>
        </div>
      </Section>
    );
  }
}
